// The only file in features/home/ that differs between Docs, Sheets and
// Slides — everything else there is a verbatim copy.

import { DriveOpenDialog } from "@/features/sheet/DriveOpenDialog";
import { SHEET_TEMPLATES } from "@/features/sheet/sheetTemplates";
import type { HomeConfig } from "./homeModel";

export const homeConfig: HomeConfig = {
    appId: "sheet",
    noun: "spreadsheet",
    nounPlural: "spreadsheets",
    kind: "sheet",
    openable: /\.(xlsx?|csv)$/i,
    searchTerms: [".xls", ".csv"],
    localAccept: ".xlsx,.xls,.csv,.json",
    editorPath: "/edit",
    allFilesOption: false,
    accent: {
        solid: "bg-emerald-700",
        soft: "bg-emerald-50 dark:bg-emerald-950/40",
        text: "text-emerald-700 dark:text-emerald-400"
    },
    thumb: "sheet",
    templateApp: "sheets",
    // Offline fallback only — the start row normally shows the suite's shared templates.
    templates: SHEET_TEMPLATES,
    DriveOpenDialog
};
